var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24C18.6274 24 24 18.6274 24 12C23.9929 5.37554 18.6245 0.00708147 12 0ZM18.606 8.32027L10.0345 16.8917C9.6998 17.2264 9.15724 17.2264 8.82256 16.8917L5.39397 13.4631C5.05346 13.1343 5.04401 12.5917 5.37288 12.2511C5.70174 11.9106 6.24435 11.9012 6.58486 12.23C6.59199 12.237 6.59902 12.244 6.60596 12.2511L9.42855 15.0737L17.394 7.10829C17.7345 6.77943 18.2771 6.78887 18.606 7.12933C18.9268 7.46151 18.9268 7.9881 18.606 8.32027Z",
    fill: "#BCCAD4"
  })));
};

export default __webpack_public_path__ + "static/media/success.da3e6743.svg";
export { SvgComponent as ReactComponent };